import {JsonProperty} from '@hyperloris/tyson';

export class PasswordSecurity {
    @JsonProperty()
    length: number = 0;
    @JsonProperty()
    lowerCaseMin: number = 0;
    @JsonProperty()
    numericalMin: number = 0;
    @JsonProperty()
    specialMin: number = 0;
    @JsonProperty()
    upperCaseMin: number = 0;
}
